import script from "./app.vue?vue&type=script&setup=true&lang=js"
export * from "./app.vue?vue&type=script&setup=true&lang=js"

import "./app.vue?vue&type=style&index=0&id=e2ef0900&lang=scss&scoped=true"
import "./app.vue?vue&type=style&index=1&id=e2ef0900&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2ef0900"]])

export default __exports__